import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '@lib/env';
import { Observable, zip } from 'rxjs';
import { IPurchaseRequisitionActive } from './purchase-requisition/types/IPurchaseRequisitionActive';
import { map } from 'rxjs/operators';
import { IRfqActive } from './types/IRfqActive';

@Injectable({ providedIn: 'root' })
export class RfqSettingsService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvService);


    public purchaseRequisitionActive(): Observable<IPurchaseRequisitionActive> {
        const uri = this.env.getBase('purchase-requisition', 'active');

        return this.http.get<IPurchaseRequisitionActive>(uri.toString());
    }

    public rfqOrPurchaseRequisitionActive(): Observable<boolean> {
        return zip(this.purchaseRequisitionActive(), this.rfqActive()).pipe(
            map(([purchaseRequisitionActive, rfqActive]) => purchaseRequisitionActive.active || rfqActive.active),
        );
    }

    private rfqActive(): Observable<IRfqActive> {
        const uri = this.env.getBase('rfq', 'active');

        return this.http.get<IRfqActive>(uri.toString());
    }
}
